import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { FacebookPixelService } from '../services/facebook-pixel';

/**
 * APP_INITIALIZER factory for Facebook (Meta) Pixel
 *
 * Initializes the Meta Pixel before the app renders, ensuring tracking
 * is available from the first page load (browser only).
 * Consent defaults to revoked - ConsentService grants it when allowed.
 */
export function initializeFacebookPixel(): () => void {
  const facebookPixelService = inject(FacebookPixelService);
  const platformId = inject(PLATFORM_ID);

  return () => {
    if (isPlatformBrowser(platformId)) {
      facebookPixelService.initialize();
    }
  };
}
